/**
 * An attachment of a map, decrypted for an export (the engine). Saving an
 * export is the interface's (interfaces/classic/ui/export-flow.js).
 */
import { VaultStorage } from '../crypto/vault-storage.js';
import { getAttachmentUrl } from './attachment-service.js';
import { t } from '../../shared/i18n/index.js';

export async function getExportAttachment(docId, attachmentId, options = {}) {
  // Online maps' DEK, or the own key of a map on this device.
  const bytes = await VaultStorage.getAttachmentKeyBytes(docId);
  if (!bytes) throw new Error(t('vault.device.fileMissing'));
  try {
    const key = await crypto.subtle.importKey('raw', bytes, 'AES-GCM', false, ['decrypt']);
    return await getAttachmentUrl(docId, attachmentId, key, options);
  } finally { bytes.fill(0); }
}
